import { createContext } from 'react';
import Storage, { StorageReturn } from './storage';
import { REDIRECT_URI_PARAM, PRODUCT_ID_PARAM, PRODUCT_ID } from '~/constants';
import { useQueryString } from '~/utils/browser';

const NEXT_PAGE_KEY = 'nextPage';

type StorageKey = typeof REDIRECT_URI_PARAM | typeof PRODUCT_ID_PARAM;
export type ProductType = PRODUCT_ID;

export const AppContext = createContext<any>(false);

// todo: add validation
export const useParameterStorage = (key: StorageKey): null => {
  const value = useQueryString(key, '');
  if (value !== '') {
    Storage.setItem(key, value);
  }
  return null;
};

export const useParameterListener = (): null => {
  useParameterStorage(REDIRECT_URI_PARAM);
  useParameterStorage(PRODUCT_ID_PARAM);
  return null;
};

export const getParamFromStorage = (key: StorageKey) => Storage.getItem(key);

export const getRedirectUrl = (): StorageReturn =>
  getParamFromStorage(REDIRECT_URI_PARAM);

export const getProductId = (): StorageReturn => {
  const storedId = getParamFromStorage(PRODUCT_ID_PARAM);
  return storedId ?? PRODUCT_ID.GENERIC;
};

export const clearProductId = (): void => Storage.removeItem(PRODUCT_ID_PARAM);

export const clearRedirect = (): void => Storage.removeItem(REDIRECT_URI_PARAM);

export const saveNextPage = (path: string): void =>
  Storage.setItem(NEXT_PAGE_KEY, path);

export const getNextPage = (): StorageReturn => Storage.getItem(NEXT_PAGE_KEY);

export const clearNextPage = (): void => Storage.removeItem(NEXT_PAGE_KEY);

export const clearAllContext = (): void => {
  clearProductId();
  clearRedirect();
  clearNextPage();
};
